import React, { useState } from "react";
import store from "src/store";
import Button from "./button";
import CustomModal from "./custom-modal";
import OrganizationForm from "./organization-form";

export default function OrganizationManagerHeader() {
    const [showCreateOrganizationModal, setShowCreateOrganizationModal] = useState(false);

    const [name, setName] = useState('');
    const [orgAdmins, setOrgAdmins] = useState([]);
    const [plan, setPlan] = useState('');
    const [executionAllowedPerMonth, setExecutionAllowedPerMonth] = useState('');
    const [allowedEngagements, setAllowedEngagements] = useState('');
    const [allowedUsers, setAllowedUsers] = useState('');

    const [nameHasError, setNameHasError] = useState(false);
    const [nameErrorText, setNameErrorText] = useState('');

    const resetOrganizationForm = () => {
        setName('');
        setOrgAdmins([]);
        setPlan('');
        setExecutionAllowedPerMonth('');
        setAllowedEngagements('');
        setAllowedUsers('');
        setNameHasError(false);
        setNameErrorText('');
    }

    const openCreateNewOrganizationModal = () => {
        resetOrganizationForm();
        setShowCreateOrganizationModal(true);
    }

    const formIsValid = () => {
        let isValid = true;

        if (!name) {
            isValid = false;
            setNameHasError(true);
            setNameErrorText("Name is required");
        } else if(store.organizations.length && store.organizations.filter((item) => (item.name == name)).length ){
            isValid = false;
            setNameHasError(true);
            setNameErrorText("Name already exists");
        } else {
            setNameHasError(false);
            setNameErrorText("");
        }

        return isValid;
    }

    const createOrganization = () => {
        if (formIsValid()) {
            let organizationData = {
                name: name,
                orgAdmins: orgAdmins,
                plan: plan,
                executionAllowedPerMonth: Number(executionAllowedPerMonth),
                allowedEngagements: Number(allowedEngagements),
                allowedUsers: Number(allowedUsers),
            };

            store.createOrganization(organizationData);
            setShowCreateOrganizationModal(false);
        }
    }

    return (
        <>
            <CustomModal
                size="medium"
                title="New organization"
                showModal={showCreateOrganizationModal}
                onCloseModal={() => { setShowCreateOrganizationModal(false) }}
                submitBtnText={'Create organization'}
                onSubmit={() => { createOrganization() }}
                submitBtnDisabled={false}
            >
                <OrganizationForm
                    name={name}
                    orgAdmins={orgAdmins}
                    plan={plan}
                    executionAllowedPerMonth={executionAllowedPerMonth}
                    allowedEngagements={allowedEngagements}
                    allowedUsers={allowedUsers}
                    setName={(value) => setName(value)}
                    setOrgAdmins={(value) => setOrgAdmins(value)}
                    setPlan={(value) => setPlan(value)}
                    setExecutionAllowedPerMonth={(value) => setExecutionAllowedPerMonth(value)}
                    setAllowedEngagements={(value) => setAllowedEngagements(value)}
                    setAllowedUsers={(value) => setAllowedUsers(value)}
                    nameHasError={nameHasError}
                    nameErrorText={nameErrorText}
                    idEdit={false}
                />
            </CustomModal>

            <div css={`
                display: flex;
                flex-direction: row;
                align-items: center;
            `}>
                <div css={`
                    width: 80%;
                `}>
                    <div css={`
                        font-size:24px;
                        color:#2E2E38;
                    `}>
                        Organization manager
                    </div>
                </div>
                <div css={`
                    width: 20%;
                `}>
                    <div css={`
                    float: right
                    `}>
                        <Button variant="contained" color="secondary" onClick={() => { openCreateNewOrganizationModal() }}>Create new organization</Button>
                    </div>
                </div>
            </div>
        </>
    )
}